import React, { useState, useContext, FormEvent, ChangeEvent, useRef, useEffect } from "react";
import { Button } from "@fluentui/react-components";
import { webUploadThrottlingCheckboxStyles } from "../../styles_glob";
import { Callout, ActionButton, PrimaryButton, Label, Text, Modal, DirectionalHint, TooltipHost, TextField, Checkbox, DefaultButton, Dropdown, IDropdownOption } from "@fluentui/react";
import {
    addUrlCallout,
    addUrlPrimaryButton,
    addUrlYouTubeCallout,
    siteMapPrimaryButton,
    textFieldStylesMultilineSiteMap,
    textFieldSiteMapStyles,
    actionButtonAddStyles,
    tooltipHostStyles,
    dropdownAddContSyncStyles,
    addSyncCalloutStyles
} from "../../styles_glob";
import { FaMicrophone } from "react-icons/fa";
import { LuFileVideo } from "react-icons/lu";
import { TbSitemap } from "react-icons/tb";
import { BiSync } from "react-icons/bi";
import { TiDeleteOutline } from "react-icons/ti";
import { CgWebsite, CgFileAdd } from "react-icons/cg";
import { FiYoutube } from "react-icons/fi";
import { FaImage } from "react-icons/fa";
import { LuFileAudio } from "react-icons/lu";
import styles from "./AddURLs.module.css";
import { publishTranscriptDraft, getSiteLinks, IUploadResponse, addUrlKgnf, uploadDocs, qGetCCAOverviews } from "../../api";
import { onSTT, isValidURL, getBaseURL } from "../../util_glob";
import MultiTagURLInput from "./multiTagURLInput";

import ConversationRecognizer from "../../components/SpeechRecognizer/ConversationRecognizer";
import { gselectedgroup, gingestioniteminfo, gtranscriptpublish, guploadfileinfodata, gailinks, guploadtextitem, ggroup } from "../../interfaces";
import { GlobalContext } from "../../GlobalContext";
import { PiTimerBold } from "react-icons/pi";
import { assistTypeOpt } from "../../lsts";


type contentType = "youtube" | "web" | "pdf" | "vid" | "mic" | "map" | "image" | "audio" | "sync";

interface Props {
    className?: string;
    updateCatsState: (newValue: string) => void;
    butName: string;
    calloutLabelText: string;
    cTy: contentType;
    listRefreshRequest: (fileids?: string) => void;
    callOutVisibility: (isVisible: boolean) => void;
    selectedGroup: gselectedgroup;
    hideCallout?: boolean;
    isfromchat?: boolean; // flag to indicate if the component is used in chat context
    acceptStr?: string; // accept string for file input
}

export const AddURLs: React.FC<Props> = ({
    className,
    updateCatsState,
    butName,
    calloutLabelText,
    cTy,
    listRefreshRequest,
    selectedGroup,
    callOutVisibility,
    hideCallout,
    isfromchat = false,
    acceptStr
}) => {
    const { user, activeComp, loggedInUser, groupList } = useContext(GlobalContext);
    const [isYoutubeCalloutVisible, setIsYoutubeCalloutVisible] = useState<boolean>(false);
    const [isPDFCalloutVisible, setIsPDFCalloutVisible] = useState<boolean>(false);
    const [isMicModalVisible, setIsMicModalVisible] = useState<boolean>(false);
    const [isSiteMapModalVisible, setIsSiteMapModalVisible] = useState<boolean>(false);
    const [isSyncModalVisible, setIsSyncModalVisible] = useState<boolean>(false);
    const [selectedSourceGroupId, setSelectedSourceGroupId] = useState<string>("");
    const [selectedSourceGroup, setSelectedSourceGroup] = useState<ggroup | null>(null);
    const [selectedAssistantTypeFilter, setSelectedAssistantTypeFilter] = useState<string>("");
    const [isYoutubeLoading, setIsYoutubeLoading] = useState<boolean>(false);
    const [isDragging, setIsDragging] = useState<boolean>(false);
    const [selectedFiles, setSelectedFiles] = useState<File[]>([]);
    const [ogFileCount, setOgFileCount] = useState<number>(0);
    const [uploadedFile, setUploadedFile] = useState<IUploadResponse>();
    const [textYWInput, setTextYWInput] = useState<string>("");
    const [siteMapInstr, setSiteMapInstr] = useState<string>("");
    const [siteMapURL, setSiteMapURL] = useState<string>("");
    const [siteMapAILinks, setSiteMapAILinks] = useState<gailinks | null>();
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [items, setItems] = useState<guploadtextitem[]>([]);
    const [webThrottlingActive, setWebThrottlingActive] = useState<boolean>(false);
    const trgtCllrRef = useRef<any>();

    useEffect(() => {
        if (isYoutubeCalloutVisible == true) setIsYoutubeLoading(false);
    }, [isYoutubeCalloutVisible]);

    useEffect(() => {
        if (selectedSourceGroupId) {
            const sourceGroup = groupList.find(g => g.groupid === selectedSourceGroupId) || null;
            setSelectedSourceGroup(sourceGroup);
        } else {
            setSelectedSourceGroup(null);
        }
    }, [selectedSourceGroupId]);


    // web¦youtube submit
    const handleTextSubmit = async (ev: React.FormEvent) => {
        ev.preventDefault();
        setIsYoutubeLoading(true);
        setIsYoutubeCalloutVisible(false);
        try {
            let itemInfo: gingestioniteminfo[] = createInfoListForWebURL(items ? items : [], selectedGroup);
            const response: IUploadResponse = await addUrlKgnf(
                textYWInput,
                selectedGroup,
                activeComp.companyid,
                user.userId,
                cTy,
                itemInfo,
                listRefreshRequest,
                webThrottlingActive,
                isfromchat
            );
            setItems([]);
            updateDynamicCatsState(textYWInput);
        } catch (error) {
            console.error(error);
        } finally {
            setIsYoutubeLoading(false);
            setIsYoutubeCalloutVisible(!isYoutubeCalloutVisible);
        }
    };

    // link map submit
    const handleURLMapSubmit = async () => {
        setIsYoutubeLoading(true);
        setIsYoutubeCalloutVisible(false);
        try {
            let itemList = siteMapAILinks?.requested_links ? siteMapAILinks?.requested_links.map(a => a[2]).slice(0, 100) : [];
            let itemInfo: gingestioniteminfo[] = createInfoListForWebScrape(itemList, selectedGroup);
            const response: IUploadResponse = await addUrlKgnf(
                itemList.join(";"),
                selectedGroup,
                activeComp.companyid,
                user.userId,
                cTy,
                itemInfo,
                listRefreshRequest,
                webThrottlingActive,
                isfromchat
            );
            setItems([]);
            setSiteMapAILinks(null);
            updateDynamicCatsState(textYWInput);
        } catch (error) {
            console.error(error);
        } finally {
            setIsYoutubeLoading(false);
            setIsYoutubeCalloutVisible(!isYoutubeCalloutVisible);
        }
    };


    // handle sync submit
    const handleSyncSubmit = async () => {
        if (!selectedSourceGroupId) return;

        setIsLoading(true);
        setIsSyncModalVisible(false);
        try {
            // Fetch CCA overviews from source group
            const response = await qGetCCAOverviews(selectedSourceGroupId, loggedInUser);
            import.meta.env.DEV && console.log("‹cca_overviews›", response);

            // Create JSON file in memory from the response
            const jsonContent  = JSON.stringify(response, null, 2);
            const jsonBlob     = new Blob([jsonContent], { type: "application/json" });
            const syncFileName = `sync_${selectedSourceGroupId}_${Date.now()}.json`;
            const jsonFile     = new File([jsonBlob], syncFileName, { type: "application/json" });

            // Create FormData like handleUploadClick
            const formData = new FormData();
            formData.append("files", jsonFile);

            // Create file info for the JSON file
            const fileInfoArray: guploadfileinfodata[] = createInfoListForFiles([jsonFile], selectedGroup, syncFileName, jsonBlob.size.toString());
            formData.append("fileInfo", JSON.stringify(fileInfoArray));

            // upload via the same ingestion path as handleUploadClick
            uploadDocs(
                formData,
                loggedInUser,
                selectedGroup.selectionId,
                listRefreshRequest,
                false, // not mp4
                isfromchat,
                selectedGroup.splitinv ?? 0,
                selectedGroup.companyid
            );

            updateCatsState(syncFileName);
        } catch (error) {
            console.error("sync error:", error);
        } finally {
            setIsLoading(false);
            setSelectedSourceGroupId('');
            setSelectedAssistantTypeFilter('');
        }
    };


    // pdf, mp4 sumbit
    const handleUploadClick = async (ev: FormEvent) => {
        ev.preventDefault();
        setIsLoading(true);
        const formData = new FormData();
        // eslint-disable-next-line @typescript-eslint/no-array-constructor
        const fileList = new Array();
        selectedFiles.forEach((file, index) => {
            formData.append(`files`, file);
            fileList.push(file.name);
        });
        let fileInfoArray: guploadfileinfodata[] = createInfoListForFiles(selectedFiles, selectedGroup);
        formData.append("fileInfo", JSON.stringify(fileInfoArray));
        try {
            const request: FormData = formData;
            setIsPDFCalloutVisible(false);
            uploadDocs(
                request,
                loggedInUser,
                selectedGroup.selectionId,
                listRefreshRequest,
                selectedFiles.some(file => file.name.toLowerCase().endsWith(".mp4")),
                isfromchat,
                selectedGroup.splitinv ?? 0,
                selectedGroup.companyid
            );
            setUploadedFile(undefined);
            setIsLoading(false);
        } catch (error) {
            setIsLoading(false);
        }
        updateCatsState(fileList.join(";"));
        setSelectedFiles([]);
    };

    // url, youtube
    const onItemsChange = (items: guploadtextitem[]) => {
        setItems(items);
        setTextYWInput(items.map(item => item.value).join(";"));
    };

    // files › pdf
    const handleFileChange = (e: ChangeEvent<HTMLInputElement>) => {
        setUploadedFile(undefined);
        const selectedFileList: File[] = [];
        if (e.target.files) {
            for (let i = 0; i < e.target.files.length; i++) {
                selectedFileList.push(e.target.files.item(i)!);
            }
        }
        setOgFileCount(selectedFileList.length);
        if (selectedFileList.length > 5) {
            setSelectedFiles(selectedFileList.slice(0, 5))
        } else {
            setSelectedFiles(selectedFileList);
        }
    };

    // remove pdf
    const handleRemoveFile = (fileToRemove: File) => {
        const filteredFiles = selectedFiles.filter(file => file !== fileToRemove);
        setSelectedFiles(filteredFiles);
        setOgFileCount(filteredFiles?.length || 0);
    };

    // drag and drop handlers
    const handleDragOver = (e: React.DragEvent<HTMLDivElement>) => {
        e.preventDefault();
        e.stopPropagation();
        setIsDragging(true);
    };

    const handleDragLeave = (e: React.DragEvent<HTMLDivElement>) => {
        e.preventDefault();
        e.stopPropagation();
        setIsDragging(false);
    };

    const handleDrop = (e: React.DragEvent<HTMLDivElement>) => {
        e.preventDefault();
        e.stopPropagation();
        setIsDragging(false);

        const droppedFiles = Array.from(e.dataTransfer.files);
        const acceptedExt = cTy === "vid" ? [".mp4"] : (acceptStr || "application/pdf,.csv").split(",").map(ext => ext.trim().toLowerCase());

        const validFiles = droppedFiles.filter(file => {
            const fileExt = "." + file.name.split(".").pop()?.toLowerCase();
            const fileType = file.type.toLowerCase();
            return acceptedExt.some(ext => ext === fileExt || ext === fileType || (ext === "image/*" && fileType.startsWith("image/")));
        });

        setOgFileCount(validFiles.length);
        if (validFiles.length > 5) {
            setSelectedFiles(validFiles.slice(0, 5));
        } else {
            setSelectedFiles(validFiles);
        }
    };

    // web scrape info list creation
    const createInfoListForWebScrape = (selectedFiles: string[], selectedGroup: gselectedgroup): gingestioniteminfo[] => {
        let fileInfoArray: any[] = [];
        selectedFiles.forEach((itmName, index) => {
            let fileInfo: guploadfileinfodata = {
                groupid: selectedGroup.selectionId,
                companyid: activeComp.companyid,
                userId: user.userId,
                fdFlName: itmName,
                fdFlSize: "0",
                sectionoverlap: selectedGroup?.sectionoverlap?.toString(),
                maxsectionlength: selectedGroup?.maxsectionlength?.toString(),
                sentencesearchlimit: selectedGroup?.sentencesearchlimit?.toString(),
                invoicesgroup: selectedGroup?.invoicesgroup?.toString(),
                usedocintel: selectedGroup?.usedocintel?.toString(),
                forceocr: selectedGroup?.forceocr?.toString(),
                assistanttype: selectedGroup?.assistanttype ?? "",
                contenttype_config: selectedGroup.contenttype_config,
                aiquestionslang: selectedGroup?.aiquestionslang ?? "",
                perchunkmeta: selectedGroup?.perchunkmeta?.toString(),
                pdfcontentlist: selectedGroup?.pdfcontentlist?.toString(),
                enhance_img: selectedGroup?.enhance_img?.toString()
            };
            fileInfoArray.push(fileInfo);
        });
        return fileInfoArray;
    };

    // web info list creation
    const createInfoListForWebURL = (selectedFiles: guploadtextitem[], selectedGroup: gselectedgroup): gingestioniteminfo[] => {
        let fileInfoArray: gingestioniteminfo[] = [];
        selectedFiles.forEach((itm, index) => {
            let fileInfo: gingestioniteminfo = {
                groupid: selectedGroup.selectionId,
                companyid: activeComp.companyid,
                userId: user.userId,
                fdFlName: itm.value, // URL
                fdFlSize: "0",
                sectionoverlap: selectedGroup?.sectionoverlap?.toString(),
                maxsectionlength: selectedGroup?.maxsectionlength?.toString(),
                sentencesearchlimit: selectedGroup?.sentencesearchlimit?.toString(),
                invoicesgroup: selectedGroup?.invoicesgroup?.toString(),
                usedocintel: selectedGroup?.usedocintel?.toString(),
                forceocr: selectedGroup?.forceocr?.toString(),
                assistanttype: selectedGroup?.assistanttype ?? "",
                contenttype_config: selectedGroup.contenttype_config,
                aiquestionslang: selectedGroup?.aiquestionslang ?? "",
                perchunkmeta: selectedGroup?.perchunkmeta?.toString(),
                pdfcontentlist: selectedGroup?.pdfcontentlist?.toString(),
                enhance_img: selectedGroup?.enhance_img?.toString(),
                extraone: itm.extra1, // Extra 1 (to allow users to paste comma separated values ⇒ custom name)
                extratwo: itm.extra2 // Extra 2 (to allow users to paste comma separated values ⇒ tags)
            };
            fileInfoArray.push(fileInfo);
        });
        return fileInfoArray;
    };

    // file info list creation
    const createInfoListForFiles = (selectedFiles: File[], selectedGroup: gselectedgroup, syncFileName?: string, jsonBlobSize?: string): guploadfileinfodata[] => {
        let fileInfoArray: guploadfileinfodata[] = [];
        selectedFiles.forEach((file, index) => {
            let fileInfo: guploadfileinfodata = {
                groupid: selectedGroup.selectionId,
                companyid: activeComp.companyid,
                userId: user.userId,
                fdFlName: syncFileName ?? file.name,
                fdFlSize: file.size.toString() ?? jsonBlobSize,
                sectionoverlap: selectedGroup?.sectionoverlap?.toString(),
                maxsectionlength: selectedGroup?.maxsectionlength?.toString(),
                sentencesearchlimit: selectedGroup?.sentencesearchlimit?.toString(),
                invoicesgroup: selectedGroup?.invoicesgroup?.toString(),
                usedocintel: selectedGroup?.usedocintel?.toString(),
                forceocr: selectedGroup?.forceocr?.toString(),
                assistanttype: selectedGroup?.assistanttype ?? "",
                contenttype_config: selectedGroup.contenttype_config,
                aiquestionslang: selectedGroup?.aiquestionslang ?? "",
                perchunkmeta: selectedGroup?.perchunkmeta?.toString(),
                pdfcontentlist: selectedGroup?.pdfcontentlist?.toString(),
                enhance_img: selectedGroup?.enhance_img?.toString(),
                convolang: selectedGroup?.convolang?.toString() ?? "",
                splitinv: selectedGroup?.splitinv?.toString() ?? "",
                usenewmodel: selectedGroup?.usenewmodel?.toString() ?? "",
                uselatestretrieval: selectedGroup?.uselatestretrieval?.toString() ?? ""
            };
            fileInfoArray.push(fileInfo);
        });
        return fileInfoArray;
    };

    // publish transcript draft
    const publishTranscriptDraftHandler = async (trnscptPbls: gtranscriptpublish, listRefreshRequest: (fileids?: string) => void) => {
        try {
            await publishTranscriptDraft(trnscptPbls, listRefreshRequest);
        } catch (error) {
            import.meta.env.DEV && console.log("‹errr_au_0009›", error);
        }
    };

    // update cats state based on cty
    const updateDynamicCatsState = (textYWInput: string) => {
        if (textYWInput.includes("youtube.com") && cTy == "youtube") {
            updateCatsState(textYWInput);
        } else if (textYWInput.includes("https") && cTy == "web") {
            updateCatsState(textYWInput);
        } else {
            updateCatsState(`${textYWInput} ¦Unsuported URL ⇛ Only Youtube Supported for Now`);
        }
    };

    // MAIN CLICK HANDLER
    const handleUploadTypeButtonClick = () => {
        trgtCllrRef.current = document.getElementById(`calloutButton_${cTy}`);
        setIsVisible(cTy);
    };

    // HIDDEN CLICK HANDLER
    const handleProgButtonClick = () => {
        trgtCllrRef.current = document.getElementById(`upldCrd_${cTy}`);
        setIsVisible(cTy);
    };

    // callout visibility handler - most of file binaries are handled via the pdf callout.
    const setIsVisible = (cTy: string) => {
        if (cTy == "pdf" || cTy == "vid") {
            setIsPDFCalloutVisible(true);
        } else if (cTy == "mic") {
            setIsMicModalVisible(true);
        } else if (cTy == "map") {
            setIsSiteMapModalVisible(true);
        } else if (cTy == "sync") {
            setIsSyncModalVisible(true);
        } else {
            setIsYoutubeCalloutVisible(true);
        }
    };

    // assistant type options for sync dropdown
    const getAssistantTypeOptions = (): IDropdownOption[] => {
        const types = new Set<string>();
        groupList
            .filter(g => g.groupid !== selectedGroup.selectionId && assistTypeOpt.hasOwnProperty(g.assistanttype ?? ''))
            .forEach(g => {
                if (g.assistanttype) types.add(g.assistanttype);
            });
        return [
            { key: "", text: "Choose Assistant Type" },
            ...Array.from(types).map(t => ({ key: t, text: assistTypeOpt[t] ?? t }))
        ];
    };

    // assistant name options for sync dropdown
    const getSyncGroupOptions = (): IDropdownOption[] => {
        return groupList
            .filter(g => g.groupid !== selectedGroup.selectionId && assistTypeOpt.hasOwnProperty(g.assistanttype ?? ''))
            .filter(g => g.assistanttype === selectedAssistantTypeFilter)
            .map(g => ({ key: g.groupid, text: g.groupname }));
    };

    // url parsing links map
    const getLinksMap = async () => {
        setSiteMapAILinks(null);
        setIsYoutubeLoading(true);
        setIsYoutubeCalloutVisible(false);
        try {
            const webResp = await getSiteLinks(siteMapURL, siteMapInstr, loggedInUser, selectedGroup.selectionId);
            let baseURL = getBaseURL(siteMapURL);
            const updatedLinks = webResp?.requested_links?.map(link => {
                if (link && link[2].indexOf("http") === -1) {
                    return { ...link, 2: (baseURL + "/" + link[2]).replace(/\/\//g, "/") };
                }
                return link;
            });
            webResp.requested_links = updatedLinks;
            setSiteMapAILinks(webResp);
        } catch (error) {
            console.error(error);
        } finally {
            setIsYoutubeLoading(false);
        }
    };

    return (
        <div className={`${styles.container} ${className ?? ""}`}>
            <div>
                <ActionButton
                    className={styles.btn_action}
                    allowDisabledFocus
                    styles={actionButtonAddStyles}
                    onClick={handleUploadTypeButtonClick}
                    disabled={isActionDisabled(cTy, selectedGroup.allowvideofiles, selectedGroup.allowyoutube, selectedGroup.allowweb, selectedGroup.allowaudiodocentry)}
                >
                    {addIconType(cTy, acceptStr)}
                </ActionButton>
                <div id={`hidB_${cTy}`} className={styles.hiddenButTrig} onClick={handleProgButtonClick}></div>

                {/*web link scraper callout*/}
                {isSiteMapModalVisible && hideCallout != true && (
                    <Callout
                        styles={addUrlYouTubeCallout}
                        role="dialog"
                        gapSpace={0}
                        className={styles.callout}
                        target={trgtCllrRef.current}
                        onDismiss={() => setIsSiteMapModalVisible(false)}
                    >
                        <form onSubmit={handleURLMapSubmit}>
                            <TextField
                                label="URL"
                                value={siteMapURL}
                                onChange={(ev, newValue) => setSiteMapURL(newValue ?? "")}
                                styles={textFieldSiteMapStyles}
                                disabled={isYoutubeLoading}
                            />
                            <TextField
                                label="AI Instructions"
                                multiline
                                rows={4}
                                value={siteMapInstr}
                                placeholder=""
                                styles={textFieldStylesMultilineSiteMap}
                                onChange={(ev, newValue) => setSiteMapInstr(newValue ?? "")}
                                disabled={isYoutubeLoading}
                            />
                            <div className={styles.addButAndLoad}>
                                <div className={styles.addAndConfig}>
                                    <PrimaryButton
                                        styles={addUrlPrimaryButton}
                                        type="submit"
                                        className={styles.submit}
                                        disabled={
                                            isYoutubeLoading ||
                                            siteMapURL.length < 1 ||
                                            siteMapInstr.length < 1 ||
                                            !isValidURL(siteMapURL) ||
                                            (siteMapAILinks?.requested_links || []).length < 1
                                        }
                                    >
                                        Add
                                    </PrimaryButton>
                                    <TooltipHost styles={tooltipHostStyles} content="Extract Content of Links from the specified URL with AI" directionalHint={DirectionalHint.bottomAutoEdge}>
                                        <PrimaryButton
                                            className={styles.siteMapButton}
                                            disabled={isYoutubeLoading || siteMapURL.length < 1 || siteMapInstr.length < 1 || !isValidURL(siteMapURL)}
                                            styles={siteMapPrimaryButton}
                                            onClick={() => getLinksMap()}
                                        >
                                            <div className={styles.centerSiteMapButton}>
                                                <TbSitemap size={20} />
                                            </div>
                                        </PrimaryButton>
                                    </TooltipHost>
                                </div>
                                {isYoutubeLoading && (
                                    <div className={styles.typingDots}>
                                        <span></span>
                                        <span></span>
                                        <span></span>
                                    </div>
                                )}
                            </div>
                        </form>
                        {(siteMapAILinks?.requested_links || []).length > 0 && (
                            <div className={styles.scrollableList}>
                                <Label>Extracted Links:</Label>
                                <ul className={styles.linkList}>
                                    {(siteMapAILinks?.requested_links || []).map((link, index) => (
                                        <li key={index} className={styles.linkItem}>
                                            <div>{link[1]}</div>
                                            <div className={styles.linksmlr}>{link[2]}</div>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        )}
                    </Callout>
                )}
                {/*youtube¦url callout*/}
                {isYoutubeCalloutVisible && hideCallout != true && (
                    <Callout
                        styles={addUrlYouTubeCallout}
                        role="dialog"
                        gapSpace={0}
                        className={styles.callout}
                        target={trgtCllrRef.current}
                        onDismiss={() => setIsYoutubeCalloutVisible(false)}
                    >
                        <form onSubmit={handleTextSubmit}>
                            <MultiTagURLInput initialItems={items} onItemsChange={onItemsChange} cTy={cTy} />
                            <div className={styles.addButAndLoad}>
                                <div className={styles.addAndConfig}>
                                    <DefaultButton
                                        styles={addUrlPrimaryButton}
                                        type="submit"
                                        className={styles.submit}
                                        title={isYoutubeLoading || items.length < 1 ? "Paste URLs in the Box above.\nIf you are writing them, press ENTER after each URL." : "Start Ingestion"}
                                        disabled={isYoutubeLoading || items.length < 1}
                                    >
                                        Start
                                    </DefaultButton>
                                    {cTy == "web" && (
                                        <div className={styles.infoIconWaitUploadWeb}>
                                            <TooltipHost content="Staggered ingest, to avoid being throttled." directionalHint={DirectionalHint.bottomAutoEdge} styles={tooltipHostStyles}>
                                                <PiTimerBold size={20}  title="Enable Web Throttling" />
                                            </TooltipHost>
                                        </div>
                                    )}
                                </div>

                                {isYoutubeLoading && (
                                    <div className={styles.typingDots}>
                                        <span></span>
                                        <span></span>
                                        <span></span>
                                    </div>
                                )}
                            </div>
                        </form>
                    </Callout>
                )}
                {/*pdf callout*/}
                {isPDFCalloutVisible && hideCallout != true && (
                    <Callout
                        role="dialog"
                        gapSpace={0}
                        styles={addUrlCallout}
                        className={styles.calloutPDF}
                        target={trgtCllrRef.current}
                        onDismiss={() => setIsPDFCalloutVisible(false)}
                    >
                        <form onSubmit={handleUploadClick} encType="multipart/form-data">
                            {selectedFiles.length === 0 && (
                                <>
                                    <div
                                        className={`${styles.dropZone} ${isDragging ? styles.dropZoneActive : ""}`}
                                        onDragOver={handleDragOver}
                                        onDragLeave={handleDragLeave}
                                        onDrop={handleDrop}
                                    >
                                        <div className={styles.dropZoneContent}>
                                            <CgFileAdd className={styles.dropZoneIcon} />
                                            <span className={styles.dropZoneText}>
                                                {isDragging ? "Drop files here" : "Drag & drop files here"}
                                            </span>
                                            <span className={styles.dropZoneDivider}>or</span>
                                            <div className={styles.btnPDF}>
                                                <Label>{cTy == "vid" ? "Choose Videos" : "Browse Files"}</Label>
                                                <input
                                                    accept={cTy == "vid" ? ".mp4" : acceptStr || "application/pdf,.csv"}
                                                    className={styles.chooseFilesPDF}
                                                    type="file"
                                                    multiple
                                                    onChange={handleFileChange}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <Text className={styles.info}>{cTy == "vid" ? "Video Files" : acceptStr == "image/*" ? "Images" : acceptStr == ".wav" ? "WAV (more formats in paid version.)" : "PDF, CSV (Contact for more...)"}</Text>
                                </>
                            )}

                            {selectedFiles.length > 0 && (
                                <div className={styles.SubmitContainerPDF}>
                                    <div className={styles.submitLabelPDF}>
                                        Selected Files ({selectedFiles.length})
                                    </div>

                                    <PrimaryButton className={styles.submitPDF} type="submit" disabled={isLoading}>
                                        <div className={styles.submitText}>Submit</div>
                                    </PrimaryButton>
                                </div>
                            )}

                            {isLoading && (
                                <div className={styles.typingDots}>
                                    <span></span>
                                    <span></span>
                                    <span></span>
                                </div>
                            )}
                            {uploadedFile && <div className={styles.padding8}>{uploadedFile.message}</div>}

                            {selectedFiles.map((item, index) => {
                                return (
                                    <div key={index} className={styles.listPDF}>
                                        <div className={`${styles.itemPDF} ${isPDFCalloutVisible ? styles.itemPDFVisible : ""}`}>{item.name}</div>

                                        <Button
                                            className={styles.removeFromListButtonPDF}
                                            icon={<TiDeleteOutline />}
                                            onClick={() => handleRemoveFile(item)}
                                        ></Button>
                                    </div>
                                );
                            })}
                            {ogFileCount > 10 && (
                                <div className={styles.onlyFive}>Only 10 files per upload are allowed in demo.</div>
                            )}
                        </form>
                    </Callout>
                )}
                {/* transcript callout */}
                {isMicModalVisible && hideCallout != true && (
                    <Modal
                        isOpen={isMicModalVisible}
                        onDismiss={() => setIsMicModalVisible(false)}
                        isBlocking={false}
                        containerClassName={styles.convoRecModalContainer}
                    >
                        <ConversationRecognizer
                            selectedGroup={selectedGroup}
                            loggedInUser={loggedInUser}
                            publishTranscriptDraftCallback={(transcriptObject: gtranscriptpublish) =>
                                publishTranscriptDraftHandler(transcriptObject, listRefreshRequest)
                            }
                            onSTT={onSTT}
                            rndo={""}
                        />
                    </Modal>
                )}
                {/* sync from group callout */}
                {isSyncModalVisible && hideCallout != true && (
                    <Callout
                        styles={addSyncCalloutStyles}
                        role="dialog"
                        gapSpace={0}
                        className={styles.callout}
                        target={trgtCllrRef.current}
                        onDismiss={() => {
                            setIsSyncModalVisible(false);
                            setSelectedAssistantTypeFilter("");
                            setSelectedSourceGroupId("");
                        }}
                    >
                        <div className={styles.syncContainer}>
                            <Label className={styles.syncLabel}>Sync Content From Other Assistants</Label>
                            <Dropdown
                                placeholder="Filter by Assistant Type"
                                label="Assistant Type"
                                styles={dropdownAddContSyncStyles}
                                options={getAssistantTypeOptions()}
                                selectedKey={selectedAssistantTypeFilter}
                                onChange={(_, option) => {
                                    setSelectedAssistantTypeFilter(option?.key as string || "");
                                    setSelectedSourceGroupId(""); // Reset group selection when type changes
                                }}
                                disabled={isLoading}
                            />
                            {
                                selectedAssistantTypeFilter && getSyncGroupOptions().length !== 0 && (
                                    <Dropdown
                                        placeholder="Select an Assistant"
                                        label="Assistant Content to Sync"
                                        styles={dropdownAddContSyncStyles}
                                        className={styles.syncGroupDropdown}
                                        options={getSyncGroupOptions()}
                                        selectedKey={selectedSourceGroupId}
                                        onChange={(_, option) => setSelectedSourceGroupId(option?.key as string || "")}
                                        disabled={isLoading}
                                    />
                                )
                            }

                            <div className={styles.addButAndLoad}>
                                <PrimaryButton
                                    styles={addUrlPrimaryButton}
                                    onClick={handleSyncSubmit}
                                    disabled={isLoading || !selectedSourceGroupId}
                                >
                                    Sync
                                </PrimaryButton>
                                {isLoading && (
                                    <div className={styles.typingDots}>
                                        <span></span>
                                        <span></span>
                                        <span></span>
                                    </div>
                                )}
                            </div>
                        </div>
                    </Callout>
                )}
            </div>
        </div>
    );
};

// display different icon based on conten type - cTy. if we use acceptStr - contentType is PDF and we modify the file type with acceptStr
const addIconType = (cTy: string, acceptStr: string | undefined) => {
    return <span className={styles.iconCntnr}>
        {cTy == "youtube" ? (
            <FiYoutube size={20} />
        ) : cTy == "web" ? (
            <CgWebsite size={20} />
        ) : cTy == "vid" ? (
            <LuFileVideo size={20} />
        ) : cTy == "mic" ? (
            <FaMicrophone size={22} />
        ) : cTy == "map" ? (
            <TbSitemap size={22} />
        ) : cTy == "sync" ? (
            <BiSync size={22} />
        ) : acceptStr == 'image/*' ? (
            <FaImage size={20} />
        ) : acceptStr == '.wav' ? (
            <LuFileAudio size={20} />
        ) : (
            <CgFileAdd size={20} />
        )}
    </span>;
}

const isActionDisabled = (cTy: string, allowvideofiles: number, allowyoutube: number, allowweb: number, allowaudiodocentry: number): boolean | undefined => {
    return cTy == "pdf"
        ? false
        : cTy == "vid" && allowvideofiles == 1
            ? false
            : cTy == "youtube" && allowyoutube == 1
                ? false
                : cTy == "web" && allowweb == 1
                    ? false
                    : cTy == "mic" && allowaudiodocentry == 1
                        ? false
                        : cTy == "map"
                            ? false
                            : cTy == "sync"
                                ? false
                                : true;
}

